import {getDaysToEvent} from '@wix/events-moment-commons'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useWidgetState} from '../../../hooks/state-provider'
import {getCountdownMarginBottom, isCountdownVisible} from '../../../selectors/single-settings'
import sc from '../../classes.scss'
import s from './countdown.scss'
import {CountdownProps} from './interfaces'

export const Countdown = ({event, onImage}: CountdownProps) => {
  const {t} = useTranslation()
  const countdownVisible = useWidgetState(isCountdownVisible)
  const marginBottom = useWidgetState(getCountdownMarginBottom)

  const daysLeft = getDaysToEvent(event)
  const text = daysLeft === 1 ? t('countdownOneDay') : t('countdownManyDays', {daysLeft})

  return countdownVisible ? (
    <div
      className={classNames(sc.textLineHeight, s.root, {
        [s.onImage]: onImage,
      })}
      data-hook="ev-countdown"
      style={{marginBottom}}
    >
      {text}
    </div>
  ) : null
}
